import React, { useEffect, useState } from "react";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";

import { base_url } from "./components/AdminUsers";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";


const Dashboard = () => {
  const navigate= useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalRecharge, setTotalRecharge] = useState(0);
  const [totalPendingRecharge, setTotalPendingRecharge] = useState(0);
  const [totalApprovedRecharge, setTotalApprovedRecharge] = useState(0);
  const [totalRejectedRecharge, setTotalRejectedRecharge] = useState(0);
  const [totalWithdrawal, setTotalWithdrawal] = useState(0);
  const [totalPendingWithdrawal, setTotalPendingWithdrawal] = useState(0);
  const [totalApprovedWithdrawal, setTotalApprovedWithdrawal] = useState(0);
  const [totalRejectedWithdrawal, setTotalRejectedWithdrawal] = useState(0);
  const [totalTodayBonus, setTotalTodayBonus] = useState(0);
  const [totalBonus, setTotalBonus] = useState(0);
  const [todayRech, setTodayRech]= useState(0);
  const [todayWith, setTodayWith]= useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [newUsers , setNewUsers] = useState(0);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };



  useEffect(()=> {
    const auth= localStorage.getItem('admin');

    const matchData = async () => {
 
      try {
        const response = await api.get(
         '/api/webapi/adminMatchapi',
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:`${auth}`,
            },
          }
        );
        // console.log("API Response:", response?.data.result);
        const data= response?.data.result;
        
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    const footballData = async () => {

      try {
        const response = await api.get(
        '/api/webapi/adminfootball',
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:`${auth}`,
            },
          }
        );
        // console.log("API Response:", response?.data.result);
        const data= response?.data.result;
  
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    const tennisData = async () => {
   
      try {
        const response = await api.get(
          '/api/webapi/admintennisapi',
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:`${auth}`,
            },
          }
        );
        // console.log("API Response:", response?.data.result);
        const data= response?.data.result;

      } catch (error) {
        console.error("API Error:", error);
      }
    };

    const fetchUserDatas = async () => {
      
      try {
        const response = await api.get(
         '/api/webapi/adminDashboardData',
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${auth}`,
            },
          }
        );
        // console.log(response.data.todayUserCount, "dasf");
        
        if(response?.data.success){
          setTotalUsers(response?.data.totalUsers || 0);
          setTotalRecharge(response?.data.totalDeposite || 0);
          setTotalPendingRecharge(response?.data.totalPendingDeposite || 0);
          setTotalApprovedRecharge(response?.data.totalApprovedDeposite || 0);
          setTotalRejectedRecharge(response?.data.totalRejectedDeposite || 0);
          setTotalWithdrawal(response?.data.totalWithdrawal || 0);
          setTotalPendingWithdrawal(response?.data.totalPendingWithdrawal || 0);
          setTotalApprovedWithdrawal(response?.data.totalApprovedWithdrawal || 0);
          setTotalRejectedWithdrawal(response?.data.totalRejectedWithdrawal || 0);
          setTotalBonus(response?.data.totalBonus || 0);
          setTotalTodayBonus(response?.data.totalTodayBonus || 0);
          setNewUsers(response?.data.todayUserCount || 0) 
        }else{
          toast.error(response?.data.message);
        }
        

      } catch (error) {
        // console.error("API Error:", error);
      }
    };

    const fetchUserToday= async()=>{
      try{
        const response= await api.get(base_url + '/api/webapi/getTodayRecharge',
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        )

        // console.log('redesds',response);

        if(response?.data.success){
          setTodayRech(response?.data.rech);
          setTodayWith(response?.data.withd);
        }

      }catch(err){
        console.log(err);
      }
    }

    matchData();
    footballData();
    tennisData();
    fetchUserDatas();
    fetchUserToday();
  },[]);


  const cardss=[
        // { label: 'Total Deposit', value: totalRecharge, url : "/admin/deposit_history" ,  bg: 'rgba(55,184,255,1)' },
        // { label: 'Today Total Deposit', value: todayRech, url : "/admin/deposit_history" , bg: '#0dcaf0' },
        // { label: 'Total Pending Deposit', value: totalPendingRecharge,url : "/admin/browse_recharge" , bg: '#fafa44' },
        // { label: 'Total Approved Deposit', value: totalApprovedRecharge,url : "/admin/deposit_history" , bg: '#34e0ad' },
        // { label: 'Total Rejected Deposit', value: totalRejectedRecharge,url : "/admin/deposit_history" , bg: '#f61f1f' },
        // { label: 'Total Withdrawal', value: totalWithdrawal,url : "/admin/withdraw_history" , bg: 'rgba(55,184,255,1)' },
        // { label: 'Today Total Withdrawal', value: todayWith,url : "/admin/withdraw_history" , bg: '#0dcaf0' },
        // { label: 'Total Pending Withdrawal', value: totalPendingWithdrawal,url : "/admin/browse_withdrawl" , bg: '#fafa44' },
        // { label: 'Total Approved Withdrawal', value: totalApprovedWithdrawal,url : "/admin/withdraw_history" , bg: '#34e0ad' },
        // { label: 'Total Rejected Withdrawal', value: totalRejectedWithdrawal,url : "/admin/withdraw_history" , bg: '#f61f1f' },
        { label: 'Total Users', value: totalUsers,url : "/admin/user" , bg: 'rgb(240 254 249)', border: '1px solid #14b09d' },
        { label: 'Total Bonus Amount', value: `${totalBonus}.00`,url : "" , bg: 'rgb(240 254 249)', border: '1px solid #14b09d' },
        { label: 'Total Today Bonus Amount', value: `${totalTodayBonus}.00`,url : "" , bg: 'rgb(240 254 249)', border: '1px solid #14b09d' },
      ];

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <>
    <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
          {/* new client within every 24 hour */}
          <div className="col-6 col-md-3 mt-3">
            <div
              className="card rounded shadow-sm"
              style={{
                
                borderLeft: "5px solid #14b09d",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = "0 15px 30px rgba(192, 173, 105, 0.9)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.08)";
              }}
            >
              <div className="card-body d-flex align-items-center gap-3">
                <div
                  className="d-flex justify-content-center align-items-center rounded-circle"
                  style={{
                    backgroundColor: "#14b09d",
                    width: "48px",
                    height: "48px",
                  }}
                >
                  <i className="fa fa-users fs-4 text-white"></i>
                </div>
                <div>
                  <p className="text-muted fw-medium mb-1">New Client</p>
                  <h4 className="text-dark fw-bold m-0">{newUsers}</h4>
                </div>
              </div>
            </div>
          </div>



          {/* 3 more cards */}
          <div className="d-flex flex-wrap gap-4">
            {/* Card 1: Add Account */}
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card mini-stats-wid rounded-4 shadow-sm h-100 border-0">
                <div className="card-body d-flex align-items-center gap-3">
                  <div className="bg-primary bg-opacity-25 text-primary p-3 rounded-circle d-flex justify-content-center align-items-center">
                    <i className="fa fa-user-plus fs-2"></i>
                  </div>
                  <div>
                    <p className="text-primary fw-semibold mb-1">Add Account</p>
                    <button className="btn btn-outline-primary border-primary btn-sm rounded-pill px-3" onClick={() => navigate('/admin/settings')}>
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Account List */}
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card mini-stats-wid rounded-4 shadow-sm h-100 border-0">
                <div className="card-body d-flex align-items-center gap-3">
                  <div className="bg-success bg-opacity-25 text-success p-3 rounded-circle d-flex justify-content-center align-items-center">
                    <i className="fa fa-address-book fs-2"></i>
                  </div>
                  <div>
                    <p className="text-success fw-semibold mb-1">Account List</p>
                    <button className="btn btn-outline-success border-success btn-sm rounded-pill px-3" onClick={() => navigate('/admin/bankList')}>
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: Global Search */}
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card mini-stats-wid rounded-4 shadow-sm border-0 h-100">
                <div className="card-body d-flex align-items-center gap-3">
                  <div className="bg-warning bg-opacity-25 text-warning p-3 rounded-circle d-flex justify-content-center align-items-center">
                    <i className="fa fa-search fs-2"></i>
                  </div>
                  <div>
                    <p className="text-warning fw-semibold mb-1">Global Search</p>
                    <button className="btn btn-outline-warning border-warning btn-sm rounded-pill px-3" onClick={() => navigate('/admin/user')}>
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        {/* <div data-v-b00d14ae className="page-content">
          <div data-v-b00d14ae>
            <div data-v-b00d14ae className="px-3" style={{overflowX: 'hidden'}}>
              <div className="row row5" style={{marginTop: '4rem'}}>
                

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'rgba(55,184,255,1)'}}>
                      
                        <p className="text-muted fw-medium text-white">Total Deposit</p>
                      <h4>{totalRecharge}</h4>
                
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body bg-info">
                      
                        <p className="text-muted fw-medium text-white">Today Total Deposit</p>
                      <h4>{todayRech}</h4>
                
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#fafa44'}}>
                      
                        <p className="text-muted fw-medium text-white">Total Pending Deposit</p>
                      <h4>{totalPendingRecharge}</h4>
                  
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#34e0ad'}}>
                     
                        <p className="text-muted fw-medium text-white">Total Approved Deposit</p>
                      <h4>{totalApprovedRecharge}</h4>
                  
                    </div>
                  </div>
                </div>
                
                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#f61f1f'}}>
                      
                        <p className="text-muted fw-medium text-white">Total Rejected Deposit</p>
                      <h4>{totalRejectedRecharge}</h4>
                  
                    </div>
                  </div>
                </div>
                
                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'rgba(55,184,255,1)'}}>
                     
                        <p className="text-muted fw-medium text-white">Total Withdrawal</p>
                      <h4>{totalWithdrawal}</h4>
                
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body bg-info">
                      
                        <p className="text-muted fw-medium text-white">Today Total Withdrawal</p>
                      <h4>{todayWith}</h4>
                
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#fafa44'}}>
                      
                        <p className="text-muted fw-medium text-white">Total Pending Withdrawl</p>
                      <h4>{totalPendingWithdrawal}</h4>
                 
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#34e0ad'}}>
                     
                        <p className="text-muted fw-medium text-white">Total Approved Withdrawal</p>
                        <h4>{totalApprovedWithdrawal}</h4>
               
                    </div>
                  </div>
                </div>
                
                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#f61f1f'}}>
                      
                        <p className="text-muted fw-medium text-white">Total Rejected Withdrawal</p>
                        <h4>{totalRejectedWithdrawal}</h4>
                   
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body" style={{background:'#80e8ff'}}>
                      
                        <p className="text-muted fw-medium text-white">Total Users</p>
                      <h4>{totalUsers}</h4>
                
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body">
                      
                        <p className="text-muted fw-medium text-white">Total Bonus Amount</p>
                      <h4>{totalBonus}.00</h4>
                    
                    </div>
                  </div>
                </div>

                <div className="col-6 col-md-3">
                  <div className="card mini-stats-wid rounded shadow">
                    <div className="card-body">
                     
                        <p className="text-muted fw-medium text-white">Total Today Bonus Amount</p>
                      <h4>{totalTodayBonus}.00</h4> 
                
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div> */}

        <div className="page-content">
          <div className="px-3" style={{ overflowX: 'hidden' }} >
            <div className="row mx-0 px-0" style={{ marginTop: '4rem', gap: '1rem 0' }}>
                {cardss.map((item, idx) => (
                  <div key={idx} className="col-6 col-md-3" >
                    <div className="card mini-stats-wid rounded-4 shadow-sm border h-100" style={{transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = "0 15px 30px rgba(192, 173, 105, 0.9)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.08)";
                    }} 
                    >
                      <div className="card-body p-3" onClick={() => window.location.href = item?.url}style={{ background: item.bg, borderRadius: '1rem', border: item.border, }}>
                        <p className="fw-semibold mb-2">{item.label}</p>
                        <h4>{item.value}</h4>
                      </div>
                    </div>
                  </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    </>
  );
};

export default Dashboard;